import React, { useContext, useEffect, useState, useRef } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';

import Back from '../components/Back';
import Button from '../components/Button';
import Input from '../components/Input';
import Layout from '../components/Layout';
import PopUp from '../components/PopUp';
import Select from '../components/Select';
import Steps from '../components/Steps';
import { GlobalContext } from '../reducers/global';
import langs from '../translations/langs';
import shouldShowImperial from '../api/utils/shouldShowImperial';

const Step2 = ({ setPage }) => {
  const {
    state: {
      child,
      options: { measurementSystem, language },
    },
    dispatch,
  } = useContext(GlobalContext);

  const { step2 } = langs[language];

  const [dob, setDob] = useState(child.birthDate || new Date());
  // const [birthDateYYYY, setBirthDateYYYY] = useState(child.birthDateYYYY);
  // const [birthDateMM, setBirthDateMM] = useState(child.birthDateMM || child.birthDateMM === 0 ? child.birthDateMM+1 : '');
  // const [birthDateDD, setBirthDateDD] = useState(child.birthDateDD);
  const [sex, setSex] = useState(step2.genderOptions ? step2.genderOptions[0] : child.sex);
  const [fatherHeight, setFatherHeight] = useState(child.FatherHeight);
  const [motherHeight, setMotherHeight] = useState(child.MotherHeight);
  const [fatherFt, setFatherFt] = useState(null);
  const [fatherIn, setFatherIn] = useState(null);
  const [motherFt, setMotherFt] = useState(null);
  const [motherIn, setMotherIn] = useState(null);

  useEffect(() => {
    const dobDate = new Date(Date.parse(dob));
    const dobText = (dobDate) ? `${dobDate.getFullYear()}-${dobDate.getMonth()+1}-${dobDate.getDate()}` : '';
    if (measurementSystem === 'imperial') {
      const fInches = fatherIn ? Number(fatherIn) : 0;
      const mInches = motherIn ? Number(motherIn) : 0;
      dispatch({
        type: 'CHILD_UPDATE',
        sex: sex && sex.length > 0 ? sex[0] : '',
        birthDate: dobText,
        birthDateYYYY: dobDate.getFullYear(),
        birthDateMM: dobDate.getMonth(),
        birthDateDD: dobDate.getDate(),
        FatherHeight: (fatherFt * 12 + fInches) * 2.54,
        MotherHeight: (motherFt * 12 + mInches) * 2.54,
      });
    } else {
      dispatch({
        type: 'CHILD_UPDATE',
        sex: sex && sex.length > 0 ? sex[0] : '',
        birthDate: dobText,
        birthDateYYYY: dobDate.getFullYear(),
        birthDateMM: dobDate.getMonth(),
        birthDateDD: dobDate.getDate(),
        FatherHeight: fatherHeight,
        MotherHeight: motherHeight,
      });
    }
  }, [dob, sex, fatherHeight, motherHeight, dispatch, fatherFt, fatherIn, motherFt, motherIn, measurementSystem]);

  const onSubmit = () => {
    setPage('step3');
    window && window.scrollTo(0, 150);
  };

  const { register, handleSubmit, control, errors } = useForm();

  return (
    <Layout>
      <Back
        onClick={() => {
          setPage('step1');
        }}
      />
      <Steps current={2} />
      <h3>{step2.title}</h3>
      <p>{step2.heightText}</p>
      <PopUp linkText={step2.heightLink} modalText={step2.heightModal} />
      <form className="form" onSubmit={handleSubmit(onSubmit)}>
        <div className="column-2 child-info">
          <div className="input-container">

          <LocalizationProvider dateAdapter={AdapterDateFns} >
            <div className={`full-width`}>
              <label htmlFor={'birthDateDD'}>
                <b style={{ fontWeight: 'normal' }}>{step2.dobLabel}<sup style={{ color: 'crimson' }}>*</sup></b>
              </label>
              <Controller
              control={control}
              name="dob"
              defaultValue={dob}
              rules={{ required: true, validate: (value) => !isNaN(Date.parse(value)) }}
              render={({ onChange, onBlur, value }) => (
                <DatePicker
                  value={value}
                  onChange={(newValue) => {
                    onChange(newValue);
                    setDob(newValue);
                  }}
                  onBlur={onBlur}
                  // selected={value}
                  renderInput={(params) => <TextField {...params} />}
                />
              )}
               />
              {errors.dob && <b style={{ fontWeight: 'normal', fontSize: 'small', color: 'crimson' }}>{step2.mmPlaceholder}/{step2.ddPlaceholder}/{step2.yyyyPlaceholder}</b>}
            </div>
          </LocalizationProvider>
            {/* <label className='col-sm-12' htmlFor={'birthDateDD'}>
              <b style={{ fontWeight: 'normal' }}>{step2.dobLabel}<sup style={{ color: 'crimson' }}>*</sup></b>
            </label>              
            <Input className="col-sm-4"
              ref={focusElement}
              register={register({ required: true })}
              required
              name="birthDateDD"
              type="number" step="1"
              min="1" max="31"
              placeholder={step2.ddPlaceholder}
              errors={errors}
              value={birthDateDD}
              setValue={setBirthDateDD}
            />

            <Input className="col-sm-4"
              register={register({ required: true })}
              required
              name="birthDateMM"
              type="number" step="1"
              min="1" max="12"
              placeholder={step2.mmPlaceholder}
              errors={errors}
              value={birthDateMM}
              setValue={setBirthDateMM}
            />

            <Input className="col-sm-4"
              register={register({ required: true })}
              required
              name="birthDateYYYY"
              type="number" step="1"
              min="1900" max="2050"
              placeholder={step2.yyyyPlaceholder}
              errors={errors}
              value={birthDateYYYY}
              setValue={setBirthDateYYYY}
            /> */}

          </div>
          <Select
            label={step2.genderLabel}
            register={register({ required: true })}
            required
            name="gender"
            errors={errors}
            placeholder={step2.genderPlaceholder}
            options={step2.genderOptions}
            value={sex}
            setValue={setSex}
          />
        </div>
        <h4>{step2.parentsSubtitle}</h4>
        {/* <p>{step2.parentsText}</p> */}
        {measurementSystem === 'imperial' ? (
          <>
            {/* IMPERIAL */}
            <div className="column-2 imperial-inputs" style={{ display: 'inline-flex' }}>
              <Input
                label={step2.dadsHeightLabelImperial}
                register={register({ required: false, min: 1, max: 9 })}
                // required
                name="dadsHeightFt"
                type="number"
                step="1"
                min="1"
                errors={errors}
                placeholder={step2.heightPlaceholderFt}
                value={fatherFt}
                setValue={setFatherFt}
              />
              <Input
                label="&nbsp;"
                register={register({ min: 0, max: 11 })}
                // required
                name="dadsHeightIn"
                type="number"
                step="1"
                min="0"
                errors={errors}
                placeholder={step2.heightPlaceholderIn}
                value={fatherIn}
                setValue={setFatherIn}
              />
            </div>
            <div className="column-2 imperial-inputs" style={{ display: 'inline-flex' }}>
              <Input
                label={step2.mumsHeightLabelImperial}
                register={register({ required: false, min: 1, max: 9 })}
                // required
                name="mumsHeightFt"
                type="number"
                step="1"
                min="1"
                errors={errors}
                placeholder={step2.heightPlaceholderFt}
                value={motherFt}
                setValue={setMotherFt}
              />
              <Input
                label="&nbsp;"
                register={register({ min: 0, max: 11 })}
                // required
                name="mumsHeightIn"
                type="number"
                step="1"
                min="0"
                errors={errors}
                placeholder={step2.heightPlaceholderIn}
                value={motherIn}
                setValue={setMotherIn}
              />
            </div>
          </>
        ) : (
          <div className="column-2">
            {/* METRIC */}
            <Input
              label={step2.dadsHeightLabelMetric}
              register={register({ required: false, min: 30, max: 300 })}
              // required
              name="dadsHeight"
              // type="number"
              step="1"
              errors={errors}
              placeholder={step2.heightPlaceholderCm}
              value={fatherHeight}
              setValue={setFatherHeight}
              errorMessage={errors['dadsHeight'] ? step2.errorHeight : ''}
            />
            <Input
              label={step2.mumsHeightLabelMetric}
              register={register({ required: false, min: 30, max: 300 })}
              // required
              name="mumsHeight"
              // type="number"
              step="1"
              errors={errors}
              placeholder={step2.heightPlaceholderCm}
              value={motherHeight}
              setValue={setMotherHeight}
              errorMessage={errors['mumsHeight'] ? step2.errorHeight : ''}
            />
          </div>
        )}
        {shouldShowImperial() && (
          <div
            className="pop-up"
            onClick={() => {
              setPage('step1');
            }}
          >
            <p className="pop-up-trigger imperial-hide">{step2.changeMeasurement}</p>
          </div>
        )}

        <Button id="calculator-step2-next" text={step2.nextButton} type="submit" />
      </form>
    </Layout>
  );
};

export default Step2;
